// GENERATED — do not edit by hand.
// Maricopa County boundary from us-atlas counties-10m (TopoJSON, FIPS 04013),
// projected equirectangular with longitude scaled by cos(mid-latitude) so the
// county is not stretched sideways. Cities use the same projection, so a
// marker lands where the place actually is.
export const VIEW = { w: 1000, h: 815 };
export const BOUNDS = { lngMin: -113.33404534545345, lngMax: -111.04048648396483, latMin: 32.50502273151731, latMax: 34.04789393582935 };
const K = 0.836032873080278, S = 494.3961643154658, PAD = 26;
export function project(lat, lng) {
  return { x: PAD + (lng - BOUNDS.lngMin) * K * S, y: PAD + (BOUNDS.latMax - lat) * S };
}
// Miles per projected unit, for the distance rings.
export const UNITS_PER_MILE = S / 69.0;
export const COUNTY_PATH = "M26.0 357.3 L26.0 50.2 L269.3 49.8 L463.7 108.0 L477.0 96.5 L477.0 78.7 L496.3 62.1 L509.6 26.0 L690.6 49.8 L785.6 49.8 L806.4 48.9 L804.9 89.3 L822.7 89.3 L819.7 106.7 L837.5 136.9 L830.1 147.0 L831.6 173.4 L850.9 188.7 L853.8 204.0 L882.0 236.2 L898.3 246.4 L904.3 230.7 L928.0 209.1 L974.0 313.5 L751.5 314.0 L750.0 442.6 L542.3 443.1 L515.6 418.4 L497.8 412.9 L493.3 390.4 L493.3 787.9 L119.5 788.8 L26.0 788.8 L26.0 357.3 Z";
